import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { SIMMONS_CATALYST_FOOTER } from '../../../actions/urlTypes';
import {
  MRI_STUDY_NAME_FLAG,
} from '../../../constants';

const findStudyInfo = props => {
  const { studyList, selectedStudy } = props;
  let studyDescription = '';
  if (selectedStudy.sti) {
    studyDescription = _.find(studyList, list =>
       _.find(list, data => _.find(data, { sti: selectedStudy.sti })
      )
    );
  }
  return studyDescription.sgd;
};

const displayStudyDataInfo = props => {
  const { selectedStudy } = props;
  let studyName = '';
  if (selectedStudy) {
    studyName = selectedStudy.ss === MRI_STUDY_NAME_FLAG
      ? findStudyInfo(props) : SIMMONS_CATALYST_FOOTER;
    studyName = `Source: ${studyName}, ${selectedStudy.sd}`;
  }
  return studyName;
};

const StudyFootnote = props => {
  return (
    <div
      className={props.className}
      id="studyInfo"
    > {displayStudyDataInfo(props)}
    </div>
  );
};

StudyFootnote.defaultProps = {
  className: 'i360-src-data-info text-align-right',
};

StudyFootnote.propTypes = {
  className: PropTypes.string,
};

export default StudyFootnote;
